import { useEffect, useState, useRef } from "react";
import JsBarcode from "jsbarcode";
import { Tags, Printer } from "lucide-react";
import { api, inr } from "@/lib/api";

function Barcode({ value, width, height }) {
  const ref = useRef(null);
  useEffect(() => { if (ref.current && value) { try { JsBarcode(ref.current, String(value), { format: "CODE128", displayValue: false, width, height, margin: 0 }); } catch (e) { console.warn("barcode render failed", value, e); } } }, [value, width, height]);
  return <svg ref={ref} />;
}

const FORMATS = {
  a4: { label: "A4 sheet (65 labels · 38×21mm)", w: 38, h: 21, cols: 5, bw: 1.1, bh: 22 },
  roll: { label: "Roll label (50×25mm)", w: 50, h: 25, cols: 1, bw: 1.4, bh: 30 },
};

export default function AdminLabels() {
  const [products, setProducts] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState({});
  const [fmt, setFmt] = useState("a4");
  const [biz, setBiz] = useState({});
  const [bulkN, setBulkN] = useState(1);

  useEffect(() => {
    api.get("/products?active_only=false&limit=1000").then((r) => setProducts(r.data));
    api.get("/admin/business-settings").then((r) => setBiz(r.data)).catch(() => {});
  }, []);

  const setQty = (id, v) => setSel((s) => ({ ...s, [id]: Math.max(0, v) }));
  const filtered = products.filter((p) => !q || p.name.toLowerCase().includes(q.toLowerCase()) || (p.sku || "").toLowerCase().includes(q.toLowerCase()));
  const f = FORMATS[fmt];

  const labels = [];
  products.forEach((p) => { const n = sel[p.id] || 0; for (let i = 0; i < n; i++) labels.push(p); });

  return (
    <div className="space-y-5" data-testid="admin-labels">
      <div className="flex items-center gap-2"><Tags className="text-emerald-600" /><h1 className="text-2xl font-bold">Barcode Labels</h1></div>
      <p className="text-sm text-slate-500">Products chuno, quantity daalo, format select karke print karo. Barcode na ho to SKU use hoga.</p>

      <div className="grid lg:grid-cols-2 gap-5 no-print">
        <div className="bg-white rounded-xl border border-slate-200 p-4 space-y-3">
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search product / SKU…" className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm" data-testid="labels-search" />
          <div className="max-h-[420px] overflow-y-auto divide-y divide-slate-50">
            {filtered.map((p) => (
              <div key={p.id} className="flex items-center gap-3 py-2" data-testid={`labels-row-${p.id}`}>
                <div className="flex-1 min-w-0"><p className="text-sm font-semibold line-clamp-1">{p.name}</p><p className="text-xs text-slate-400">{p.barcode || p.sku} · {inr(p.price)}</p></div>
                <input type="number" min="0" value={sel[p.id] || 0} onChange={(e) => setQty(p.id, parseInt(e.target.value) || 0)} className="w-16 border border-slate-300 rounded-lg px-2 py-1 text-sm text-center" data-testid={`labels-qty-${p.id}`} />
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-4 space-y-3 h-fit">
          <p className="text-xs font-bold text-slate-500">Label format</p>
          {Object.entries(FORMATS).map(([k, v]) => (
            <label key={k} className="flex items-center gap-2 text-sm font-medium"><input type="radio" name="fmt" checked={fmt === k} onChange={() => setFmt(k)} className="accent-emerald-600" data-testid={`labels-fmt-${k}`} /> {v.label}</label>
          ))}
          <p className="text-xs font-bold text-slate-500 pt-1">Bulk fill (each ×N)</p>
          <div className="flex gap-2">
            <input type="number" min="0" value={bulkN} onChange={(e) => setBulkN(parseInt(e.target.value) || 0)} className="w-20 border border-slate-300 rounded-lg px-2 py-1.5 text-sm text-center" data-testid="labels-bulk" />
            <button data-testid="labels-bulk-apply" onClick={() => { const next = { ...sel }; filtered.forEach((p) => { next[p.id] = bulkN; }); setSel(next); }} className="flex-1 py-1.5 bg-slate-800 text-white rounded-lg text-xs font-bold">Apply ×{bulkN} to shown</button>
            <button data-testid="labels-clear" onClick={() => setSel({})} className="px-3 py-1.5 border border-slate-300 rounded-lg text-xs font-bold text-slate-600">Clear</button>
          </div>
          <p className="text-sm text-slate-600">Total labels: <b data-testid="labels-count">{labels.length}</b></p>
          <button data-testid="labels-print" disabled={!labels.length} onClick={() => window.print()} className="w-full py-2.5 bg-emerald-600 disabled:opacity-50 text-white rounded-lg font-bold flex items-center justify-center gap-2"><Printer size={16} /> Print Labels</button>
        </div>
      </div>

      {/* Print sheet */}
      <div className="label-sheet" data-testid="labels-sheet">
        <style>{`
          .label-sheet{display:flex;flex-wrap:wrap;gap:2mm}
          .lbl{width:${f.w}mm;height:${f.h}mm;border:1px dashed #e2e8f0;box-sizing:border-box;padding:1mm 1.5mm;display:flex;flex-direction:column;align-items:center;justify-content:center;overflow:hidden}
          .lbl .nm{font-size:7pt;font-weight:700;line-height:1.05;text-align:center;max-height:14pt;overflow:hidden}
          .lbl .pr{font-size:9pt;font-weight:800}
          .lbl svg{max-width:100%}
          @media screen{.label-sheet{background:#fff;padding:8px;border:1px solid #e2e8f0;border-radius:12px}}
          @media print{.no-print{display:none!important} .label-sheet{gap:0} .lbl{border:none} @page{margin:6mm}}
        `}</style>
        {labels.map((p, i) => (
          <div className="lbl" key={`${p.id}-${i}`}>
            <div className="nm">{p.name}</div>
            <Barcode value={p.barcode || p.sku} width={f.bw} height={f.bh} />
            <div style={{ fontSize: "6pt" }}>{p.barcode || p.sku}</div>
            <div className="pr">{inr(p.price)}{p.mrp > p.price ? <span style={{ fontSize: "6pt", textDecoration: "line-through", marginLeft: 3, fontWeight: 400 }}>{inr(p.mrp)}</span> : null}</div>
          </div>
        ))}
        {!labels.length && <p className="no-print text-slate-400 text-sm">Quantity daalo to labels yahan preview honge.</p>}
      </div>
    </div>
  );
}
